__turbopack_context__.v({
  "desktopOnly": "Wallet-module__tuJdLq__desktopOnly",
  "legacyLink": "Wallet-module__tuJdLq__legacyLink",
  "line": "Wallet-module__tuJdLq__line",
  "mobileOnly": "Wallet-module__tuJdLq__mobileOnly",
  "modal": "Wallet-module__tuJdLq__modal",
  "root": "Wallet-module__tuJdLq__root",
  "tabSection": "Wallet-module__tuJdLq__tabSection",
  "tabs": "Wallet-module__tuJdLq__tabs",
  "title": "Wallet-module__tuJdLq__title",
  "titleActionButton": "Wallet-module__tuJdLq__titleActionButton",
  "titleActionIcon": "Wallet-module__tuJdLq__titleActionIcon",
  "walletHistoryStatus": "Wallet-module__tuJdLq__walletHistoryStatus",
});
